import { defineComponent as _defineComponent } from 'vue'
import { AbRadio } from '../../components/ui';
import type { Field } from '../types';
import { getAttributeValue, isOptionsArray } from '../utils';
import { computed } from 'vue';


export default /*#__PURE__*/_defineComponent({
  __name: 'FormFieldRadio',
  props: {
    value: null,
    field: null,
    error: null,
    disabled: { type: Boolean }
  },
  emits: ["input"],
  setup(__props: any) {

const props = __props as {
  value: any;
  field: Field;
  error?: string;
  disabled?: boolean;
};





const options = computed(() => {
  const opts = getAttributeValue(props.field, 'options');
  if (!isOptionsArray(opts) || !opts.length) {
    console.warn('FormFieldRadio: options must be a non-empty array');
    return [];
  }
  return opts;
});

return { __sfc: true,props, options, AbRadio, getAttributeValue }
}

})